import type { ServiceAuthFactory } from "../../../services/auth/types";
import { LogoCloudAuthAdapter } from "./adapter";

export const logocloudAuthFactory: ServiceAuthFactory = {
  addinKey: "logocloud",
  create(cfg, deps) {
    return new LogoCloudAuthAdapter(cfg, deps);
  },
};
